import React from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';

import TransferRecordsContainer from './transfer_records_container';

export function TransferRecordsPortal({ transferRecordBatch, onReady }) {
  const domNode = document.getElementById('transfer-database-records-progress');

  if (!domNode) {
    return null;
  }

  return createPortal(
    <TransferRecordsContainer
      transferRecordBatch={transferRecordBatch}
      onReady={onReady}
    />,
    domNode
  );
}

TransferRecordsPortal.propTypes = {
  transferRecordBatch: PropTypes.object,
  onReady: PropTypes.func
};

export default TransferRecordsPortal;
